import PromotionTrackedLinksContent from './PromotionTrackedLinksContent';

export default PromotionTrackedLinksContent;
